import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Play } from 'lucide-react';

const VideoSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {language === 'en' ? 'LiDAR Processing in Action' : 'Përpunim LiDAR në Veprim'}
            </h2>
            <p className="text-xl text-gray-600">
              {language === 'en' 
                ? 'See how our advanced LiDAR technology captures and processes data' 
                : 'Shikoni si teknologjia jonë e avancuar LiDAR kapur dhe përpunon të dhënat'}
            </p>
          </div>

          {/* Video Container */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <video
              controls
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-auto"
              poster="https://customer-assets.emergentagent.com/job_space-data-1/artifacts/6bly07t9_IMG-20250813-WA0046.jpg"
            >
              <source 
                src="https://customer-assets.emergentagent.com/job_space-data-1/artifacts/6asv2m9g_LiDAR-processing.mp4" 
                type="video/mp4" 
              />
              {language === 'en' 
                ? 'Your browser does not support the video tag.' 
                : 'Shfletuesi juaj nuk mbështet video.'}
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
